import _ from 'underscore';
import 'core-js/fn/array/find';

const service = [
    'SimpleApiFactory',
    '$resource',
    '$rootScope',
];

const fn = (
    SimpleApiFactory,
    $resource,
    $rootScope
) => {
    const F = {};

    F.data = [];

    F.resource = function() {
        return $resource('/api/public/product', {id: '@id'});
    };

    F.fetch = function() {
        return F.resource().get({}, (response) => {
            const parsedResponse = SimpleApiFactory.parse(response);

            if(!parsedResponse.status) {
                return console.error('Unable to fetch Products.');
            }

            F.data = response.data;

            $rootScope.$emit('ProductsFetched');
        }, (body) => {
            console.error('Unable to fetch Products.', body);
        });
    };

    F.getProducts = function() {
        return _.values(F.data);
    };

    F.findById = function(id) {
        return F.getProducts().find((product) => product.id === +id);
    };

    F.getClasses = function() {
        const classes = F.getProducts().map((product) => {
            return product.class;
        });

        return _.uniq(classes);
    };

    F.findByStaticName = function(staticName) {
        return F.getProducts().find((item) => {
            return item.static_name === staticName;
        });
    };

    return F;
};

service.push(fn);

export default service;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/services/ProductsFactory.js